export default {
  data() {
    return {
      validatedFields: {},
      serverErrors: []
    };
  },

  computed: {
    submitStatus() {
      const hasAllRequired = this.requiredFields.every(
        required => Object.keys(this.validatedFields).some(f => f === required));
      const allRequiredHasValue = Object.values(this.validatedFields).every(item => item !== false);
      return hasAllRequired && allRequiredHasValue ? "success" : "error";
    }
  },

  methods: {
    onValidateField(obj) {
      this.validatedFields = { ...this.validatedFields, ...obj };
    }
  }
};
